import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';

import { orgManagerApiRef } from './apis/OrgManagerApi';
import { OrgManagerClient } from './apis/OrgManagerClient';
import { rootRouteRef } from './routes';

export const orgManagerPlugin = createPlugin({
  id: 'org-manager',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: orgManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        fetchApi: fetchApiRef,
        microsoftAuthApi: microsoftAuthApiRef,
      },
      factory: deps => {
        return OrgManagerClient.create(deps);
      },
    }),
  ],
});

export const OrgPage = orgManagerPlugin.provide(
  createRoutableExtension({
    name: 'OrgPage',
    component: () => import('./components/OrgPage').then(m => m.OrgPage),
    mountPoint: rootRouteRef,
  }),
);
